<button *ngIf="!this.disableCloseButton" mat-icon-button (click)="this.handleClick(null)" class="pme-dialog-button-close">
  <mat-icon>close</mat-icon>
</button>

<div class="pme-dialog-info">
  <mat-dialog-content>
    <pme-new-hero
      title="{{this.heroData.title}}"
      type="{{this.heroData.type}}">
      <div *ngFor="let content of this.heroData.contents" [innerHTML]="content"></div>
    </pme-new-hero>
  </mat-dialog-content>

  <mat-dialog-actions align="center"> 
    <div class="modal-actions">
      <a class="modal-button secondary" mat-button color="primary" (click)="handleClick('SECONDARY')" *ngIf="this.buttonData && this.buttonData.secondary">
        {{this.buttonData.secondary.title}}
      </a>
      <button class="modal-button" [ngClass]="{'blue': this.buttonData.secondary}" mat-flat-button color="primary" type="submit" (click)="handleClick('PRIMARY')">
        {{this.buttonData.primary.title}}
      </button>
    </div>
  </mat-dialog-actions>

</div>
